import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BranchesPage from './pages/BranchesPage';
import ComparisonPage from './pages/ComparisonPage';
import FranchiseSettingsPage from './pages/FranchiseSettingsPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import InquiryPage from './pages/InquiryPage';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/branches"
        element={
          <PrivateRoute>
            <BranchesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/comparison"
        element={
          <PrivateRoute>
            <ComparisonPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/franchise"
        element={
          <PrivateRoute>
            <FranchiseSettingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/account"
        element={
          <PrivateRoute>
            <AccountSettingsPage />
          </PrivateRoute>
        }
      />
      <Route path="/settings" element={<Navigate to="/settings/franchise" replace />} />
      <Route
        path="/inquiry"
        element={
          <PrivateRoute>
            <InquiryPage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
